"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMotionProps = exports.getMotionProps = void 0;
var _react = require("react");
var _utils = require("./utils");
const _excluded = ["enterConfigs", "exitConfigs", "initial", "animate", "transition"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const getVariants = (enterConfigs, exitConfigs) => {
  if (!enterConfigs && !exitConfigs) return undefined;
  const variant = {};
  if (enterConfigs) {
    variant.enter = (0, _utils.createVariant)(enterConfigs);
  }
  if (exitConfigs) {
    variant.exit = (0, _utils.createVariant)(exitConfigs);
  }
  return variant;
};
const getMotionProps = _ref => {
  let enterConfigs = _ref.enterConfigs,
    exitConfigs = _ref.exitConfigs,
    _ref$initial = _ref.initial,
    initial = _ref$initial === void 0 ? 'exit' : _ref$initial,
    _ref$animate = _ref.animate,
    animate = _ref$animate === void 0 ? 'enter' : _ref$animate,
    transition = _ref.transition,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Object.assign({
    variants: getVariants(enterConfigs, exitConfigs),
    initial,
    animate,
    transition: transition && (0, _utils.convertTransition)(transition)
  }, rest);
};

/**
 * Convert CDS motion configs to framer motion props.
 * @warning Use the function version(getMotionProps) if possible to avoid unnecessary rerenders.
 * @link https://www.framer.com/docs/component/##animation
 */
exports.getMotionProps = getMotionProps;
const useMotionProps = props => {
  return (0, _react.useMemo)(() => getMotionProps(props), [props]);
};
exports.useMotionProps = useMotionProps;